export enum LangDirection {
  RLT = 'rtl',
  LTR = 'ltr',
}
